// 1. 引入你需要的组件
import { Button, Toast, Form, Field, CellGroup } from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function phone(vue: any) {
    vue.use(Button).use(Toast).use(Form).use(Field).use(CellGroup);
}
